<template>
  <div class="store__order-summary">
    <h1 class="store-headline">{{ headline }}</h1>

    <div v-html="content"></div>

    <div v-if="! plan && numCartItems <= 0">
      <div class="mb-4">
        <p>Your cart is currently empty.</p>
        <router-link :to="{ name: 'products' }" class="btn btn-store"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="#363636" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"/></svg> Continue Shopping</router-link>
      </div>
    </div>

    <div class="mb-4" v-if="plan || numCartItems > 0">
      <div class="cart">
        <div class="row cart-row cart-row--header">
          <div class="col-5 col--product">Product</div>
          <div class="col-2">Qty</div>
          <div class="col-2 col--unit-price">Unit Price</div>
          <div class="col-2 text-end">Subtotal</div>
          <div class="col-1"> </div>
        </div>

        <div class="row cart-row cart-row--plan" v-if="plan">
          <div class="col-7 col--plan">
            <div class="plan__img">
              <router-link :to="{ name: 'plans'}">
                <img v-bind:src="plan.image" alt="">
              </router-link>
            </div>
            <div class="plan__info">
              <strong>{{ plan.name }}</strong><br>
              {{ plan.numberOfPeople }} <span v-if="plan.numberOfPeople">/</span> {{ plan.numberOfGallons }}
            </div>
          </div>
          <div class="col-2 col--unit-price"></div>
          <div class="col-2 text-end plan__price">
            ${{ plan.price }}
          </div>
          <div class="col-1">
            <button 
              v-on:click="removePlanFromCart()" 
              title="Remove from Cart" 
              class="btn btn-trash"
              role="button"
            ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"/></svg></button>
          </div>
        </div> <!-- .cart-row -->

        <div class="row cart-row cart-row--upgrade" v-if="planUpgrade">
          <div class="col-7 col--product">{{ planUpgrade.name }}</div>
          <div class="col-2 col--unit-price"></div>
          <div class="col-2 text-end">
            ${{ numberFormat(planUpgrade.price) }}
          </div>
          <div class="col-1"></div>
        </div> <!-- .cart-row -->

        <div v-for="(item, index) in cart">
          <div class="row cart-row">
            <div class="col-5 col--product">
              <div class="product__img">
                <router-link :to="{ name: 'product-detail', params: { productId: item.product.id }}">
                  <img v-bind:src="item.product.image" alt="">
                </router-link>
              </div>
              <div class="product__info">
                <span v-html="item.product.name"></span>
                <small class="variant">{{ getItemVariants(item) }}</small>
              </div>
            </div>
            <div class="col-2">
              <select v-bind:value="item.options.quantity" v-on:change="updateQuantity" v-bind:data-index="index" class="form-select form-select-sm">
                <option v-for="i in getItemQuantityRange(item)" v-bind:value="i">{{ i }}</option>
              </select>
            </div>
            <div class="col-2 col--unit-price">${{ numberFormat(getProductUnitCost(item)) }}</div>
            <div class="col-2 text-end">${{ numberFormat(getProductUnitCost(item) * item.options.quantity) }}</div>
            <div class="col-1">
              <button 
                v-on:click="removeFromCart(index)" 
                title="Remove from Cart" 
                class="btn btn-trash"
                role="button"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"/></svg></button>
            </div>
          </div> <!-- .cart-row -->

          <div class="row cart-row" v-if="itemIsGallonWater(item) && itemHasGallonWaterCooler(item)">
            <div class="col-5 col--product">
              <div class="product__img">
                <img v-bind:src="getGallonWaterCoolerImage(item)" alt="">
              </div>
              <div class="product__info">
                {{ getGallonWaterCoolerLabel(item) }}
                <small class="variant">{{ getGallonWaterCoolerColor(item) }}</small>
              </div>
            </div>
            <div class="col-2">1</div>
            <div class="col-2 col--unit-price">${{ numberFormat(getGallonWaterCoolerPrice(item)) }}</div>
            <div class="col-2 text-end">${{ numberFormat(getGallonWaterCoolerPrice(item)) }}</div>
            <div class="col-1"> </div>
          </div>

          <div class="row cart-row col--offer" v-if="item.options.offer">
            <div class="col-5 col--product">{{ item.product.offer.name }}</div>
            <div class="col-2"></div>
            <div class="col col--unit-price col-2"></div>
            <div class="col-2 text-end no-wrap">
              - ${{ item.product.offer.discount }}
            </div>
            <div class="col-1"> </div>
          </div> <!-- .cart-row -->
        </div>

        <div class="row cart-row col--offer" v-if="offer">
          <div class="col-5 col--product">{{ offer.name }}</div>
          <div class="col-2"></div>
          <div class="col col--unit-price col-2"></div>
          <div class="col-2 text-end no-wrap">
            <template v-if="offerDiscount > 0">- ${{ offerDiscountFormatted }}</template>
          </div>
          <div class="col-1"> </div>
        </div> <!-- .row -->

        <div class="row cart-row" v-if="refundableBottleDeposit">
          <div class="col-11 text-end">
            Refundable Bottle Deposit: 
            <span v-if="refundableBottleDeposit > 0">${{ refundableBottleDeposit }}</span> 
            <span v-else>Waived</span>
          </div>
          <div class="col-1"></div>
        </div>

        <div class="crow cart-row">
          <div class="col-11 text-end">Delivery Fee: {{ deliveryFee > 0 ? '$' + numberFormat(deliveryFee) : 'Waived' }}</div>
          <div class="col-1"></div>
        </div>

        <div class="crow cart-row" v-if="fuelSurcharge > 0">
          <div class="col-11 text-end">Fuel Surcharge: ${{ numberFormat(fuelSurcharge) }}</div>
          <div class="col-1"></div>
        </div>

        <div class="row cart-row cart-row--total">
          <div class="col-11 text-end">Total: ${{ cartTotal }}</div>
          <div class="col-1"></div>
        </div>
      </div> <!-- .cart -->

      <div class="cart-lower">
        <div class="cart-lower__disclaimer">
          <div v-html="disclaimer"></div>
        </div>

        <div class="cart-lower__options">
          <router-link :to="{ name: 'home' }" class="back"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="#006699" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"/></svg> Continue Shopping</router-link> 
          <router-link :to="{ name: 'checkout' }" class="btn btn-store">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#ffffff" d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/></svg> Checkout
          </router-link>
        </div>
      </div> <!-- .cart-lower -->
    </div>

    <related-products
      headline="Don’t forget to add these products to your order:"
      useCartProducts="true"
    ></related-products>

  </div> <!-- .store__order-summary -->
</template>

<script>
import store from '../store.js'
import mixins from '../mixins.js'
import RelatedProducts from './RelatedProducts.vue'

export default {
  mixins: [mixins],
  data() {
    return {
      headline: 'Order Summary',
      content: '',
    }
  },
  computed: {
    pluginUrl() {
      return store.state.pluginUrl
    },
    disclaimer() {
      return store.state.settings.disclaimer || ''
    },
    cart() {
      return store.getters.cartItems
    },
    numCartItems() {
      return store.getters.numCartItems
    },
    deliveryFee () {
      return store.getters.getDeliveryFee
    },
    fuelSurcharge () {
      return store.getters.getFuelSurcharge
    },
    initialDeliveryTotal() {
      return this.numberFormat(store.getters.initialDeliveryTotal)
    },
    refundableBottleDeposit() {
      return this.numberFormat(store.getters.refundableBottleDeposit)
    },
    cartTotal() {
      return this.numberFormat(store.getters.cartTotal)
    },
    offer() {
      return store.state.offer
    },
    offerDiscount() {
      return store.getters.cartOfferDiscount
    },
    offerDiscountFormatted() {
      return this.numberFormat(this.offerDiscount)
    },
    plan() {
      return store.state.plan
    },
    planUpgrade() {
      return store.getters.cartPlanUpgrade
    },
  },
  components: {
    RelatedProducts,
  },
  created() {
    // console.log(store.getters.cartItems)
    // Page content
    // this.headline = window.pages.order_summary.page.headline || ''
    // this.content = window.pages.order_summary.page.content || ''
  },
  mounted() {
    store.dispatch('setCurrentStep', 'order-summary')
  },
  methods: {
    removePlanFromCart() {
      store.dispatch('removePlanFromCart')
    },
    updateQuantity(e) {
      store.dispatch('updateCartItemQuantity', {
        index: e.target.dataset.index,
        quantity: e.target.value
      })
    },
    removeFromCart(index) {
      store.dispatch('removeFromCart', index)
    },
    getProductUnitCost(item) {
      return store.getters.getProductUnitCost(item)
    },
    getCartItemSubtotal(item) {
      return store.getters.getCartItemSubtotal(item)
    },
    itemIsGallonWater(item) {
      return item.product.type == 'gallon-water'
    },
    getItemVariants(item) {
      if (item.product.type == 'gallon-water') {
        return this.getGallonWaterSelections(item)
      }
      return this.getProductFlavorName(item)
    },
    getGallonWaterSelections(item) {
      let selections = []
      selections.push(item.product.size)

      // let cooler = store.getters.getGallonWaterCooler(item.options.cooler)
      // if (cooler) {
      //     selections.push(cooler.label + ' Cooler (+$' + cooler.price + ')')
      // }

      // if (item.options.coolerColor) {
      //     selections.push(item.options.coolerColor)
      // }

      return selections.join(', ')
    },
    itemHasGallonWaterCooler(item) {
      return item.options.cooler
    },
    getGallonWaterCooler(item) {
      return item.options.cooler
    },
    getGallonWaterCoolerImage(item) {
      let cooler = this.getGallonWaterCooler(item)
      if (cooler) {
        return cooler.image
      }
    },
    getGallonWaterCoolerLabel(item) {
      let cooler = this.getGallonWaterCooler(item)
      if (cooler) {
        return cooler.name + ' Cooler'
      }
    },
    getGallonWaterCoolerColor(item) {
      return item.options.coolerColor
    },
    getGallonWaterCoolerPrice(item) {
      let cooler = this.getGallonWaterCooler(item)
      if (cooler) {
        return cooler.price
      }
    },
    getProductFlavor(item) {
      return store.getters.getProductFlavor(item)
    },
    getProductFlavorName(item) {
      return store.getters.getProductFlavorName(item)
    },
    getProductFlavorPrice(item) {
      return store.getters.getProductFlavorPrice(item)
    },
    getItemQuantityRange(item) {
      let range = []
      for (let i = this.getMinItemQuantity(item); i <= this.getMaxItemQuantity(item); i++) {
        range.push(i)
      }
      return range
    },
    getMinItemQuantity(item) {
      if (this.itemIsGallonWater(item)) {
        return 3
      }
      return item.product.minimumQuantity || 1
    },
    getMaxItemQuantity(item) {
      let max = item.product.maximumQuantity || 10
      return item.options.quantity > max ? item.options.quantity : max
    }
  }
}
</script>
